<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="agendamentoExame"
                        label="Grupo"
                        show-default-option
                        text-field="nome"
                        v-model="model.exameId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadeSolicitante"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        valueField="id"
                        show-default-option
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            class="mt-2"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            sort-by="data"
        >

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Imprimir"
                    color="primary"
                    @click="print(item)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: "quantidade",
                    label: "Quantidade",
                    class: 'col-min',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        infraestruturas() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.id == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },

    },
    created() {

        this.repositories = {
            mapaDia: this.getConectaSusRepository('exameLaboratorial.mapaDia'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                exame: null,
                exameId: null,
                exameNome: null,
                unidadeId: null,
                infraestruturaId: null,
                agendamentoId: null,
                pertenceGrupo: null,
                mapaAgrupado: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            itemsNotSave: null,
            unidadeSolicitante: [],
            agendamentoExame: [],
            items: [],
            enums: {
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        search() {

            this.setLoading()

            this.repositories.mapaDia.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams(item) {

            const params = this.clone(this.model)

            if (item) {

                params.agendamentoId = item.agendamentoId
                params.exameId = item.exameGrupoId
                params.pertenceGrupo = item.pertenceGrupo
                params.mapaAgrupado = item.mapaAgrupado
            }

            if (this.model.exameId) {

                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

               this.model.unidadeNome = this.data.form.unidades.find(u => u.id == this.model.unidadeId).nomeFantasia
            }

            if (this.model.infraestruturaId) {

               this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            const infraestrutura =infraestruturaPrincipal
                .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                if (infraestrutura) {

                    this.model.unidadeId = this.data.form.unidadeId
                    this.model.infraestruturaId = this.data.form.infraestruturaId
                } else if (infraestruturaPrincipal.find(u => u.principal)) {

                    this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal).id
                } else {

                    this.model.infraestruturaId = null
                }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        print(item) {

            if (item.composicao == null) {

                this.showValidationNotification(`Para realizar a impressão, é necessário cadastrar a composição do exame.`)

            } else {

                this.setLoading()

                this.repositories.impressao.mapaDia(this.getSearchParams(item))
                    .then(response => {

                        const content = new Blob([response.data], {type: response.headers['content-type']})
                        const url = URL.createObjectURL(content)
                        const link = document.createElement('a')

                        link.href = url
                        link.target = '_blank'
                        link.click()
                        link.remove()
                    })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
            }
        },
        loadFields() {

            this.setLoading()

            this.repositories.mapaDia.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.unidades)
                    this.agendamentoExame = data.grupos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(unidades) {

            this.unidadeSolicitante = unidades

            const unidade = unidades.find(u => u.id == this.data.form.unidadeId);

            if (unidade) {

                const infraestrutura = unidade.infraestruturas
                    .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                    if (infraestrutura) {
                        this.model.unidadeId = this.data.form.unidadeId
                        this.model.infraestruturaId = this.data.form.infraestruturaId
                    }
            }
        },
        setListagem() {

            this.itemsNotSave = null
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>